export const billingsKeys = {
  all: ["site-billing"] as const,
  lists: () => [...billingsKeys.all, "list"] as const,
  list: () => [...billingsKeys.lists()] as const,
  details: () => [...billingsKeys.all, "detail"] as const,
  detail: () => [...billingsKeys.details()] as const,
};
